import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthOidcService } from '@cddng/auth-oidc-apim';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private readonly oidcService = inject(AuthOidcService);

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header.
    let customHeaders = httpRequest.headers;
    // Securisation des appels vers le bff uniquement
    if((httpRequest.url.includes(environment.bff_affectation_server) || httpRequest.url.includes(environment.bff_appairage_server) || httpRequest.url.includes(environment.bff_recap_server))) {
      if (environment.apim_env === 'sacc') {
        customHeaders = httpRequest.headers
          .set( 'Authorization', 'Bearer ' + this.oidcService.storage.apimIdToken )
          .set( 'APIM-O2-EndPoint', environment.apim_env );
      } else if (environment.apim_env === 'prod') {
        customHeaders = httpRequest.headers
          .set( 'Authorization', 'Bearer ' + this.oidcService.storage.apimIdToken );
      } else {
        customHeaders = httpRequest.headers
          .set( 'JWT_TOKEN', this.oidcService.storage.idToken );
      }
    }

    const authReq = httpRequest.clone({ headers: customHeaders });
    // Pass on the cloned request instead of the original request.
    return next.handle(authReq).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
